(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/iam-idp/assets/javascripts/react/components/bank-id/bank-id-start.js') >= 0) return;  svs.modules.push('/modules/iam-idp/assets/javascripts/react/components/bank-id/bank-id-start.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _svs$ui = svs.ui,
  Button = _svs$ui.Button,
  Bank = _svs$ui.ReactBank;
const postMessageToParent = svs.iam_idp.utils.postMessageToParent;
const PARENT_REDIRECT = svs.iam_idp.constants.POST_MESSAGE_TYPES.PARENT_REDIRECT;
const _svs$iam_idp$componen = svs.iam_idp.components.shared,
  Qr = _svs$iam_idp$componen.Qr,
  SelectorButtons = _svs$iam_idp$componen.SelectorButtons;
const isPnp = svs.iam_idp.data.isPnp;
const isMobile = svs.core.detect.formfactor.mobile();
const login = svs.iam_idp.utils.Login;
const Loader = svs.components.ReactLoader.Loader;
const _React = React,
  useState = _React.useState;
const _jotai = jotai,
  useAtomValue = _jotai.useAtomValue;
const activeMethodAtom = svs.iam_idp.atoms.activeMethodAtom;
const BankIdStart = _ref => {
  let showQR = _ref.showQR,
    isNewCustomer = _ref.isNewCustomer;
  const activeMethod = useAtomValue(activeMethodAtom);
  const rawReturnUrl = svs.utils.url.queryString.returnUrl;
  const returnUrl = rawReturnUrl ? svs.utils.url.makeInternal(rawReturnUrl) : null;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showAppLoader = _useState2[0],
    setShowAppLoader = _useState2[1];
  const handleClick = () => {
    if (showQR) {
      login.startBankIdSameDevice(isNewCustomer);
      setShowAppLoader(true);
    } else {
      login.start(activeMethod.isFreja, isNewCustomer);
    }
  };
  return React.createElement("div", null, showAppLoader ? React.createElement("div", {
    className: "spinner-container margin-bottom-1"
  }, React.createElement("p", {
    className: "spinner-container-text"
  }, "F\xF6rs\xF6ker starta BankID-appen"), React.createElement(Loader, null)) : React.createElement("div", null, React.createElement(SelectorButtons, null), showQR && React.createElement(Qr, {
    isNewCustomer: isNewCustomer,
    isPnp: isPnp
  }), React.createElement("div", {
    className: "login-buttons-container"
  }, React.createElement(Button, {
    block: true,
    className: "margin-top-1 margin-bottom-1",
    focus: isMobile,
    iconPosition: "left",
    inverted: true,
    onClick: handleClick,
    size: 300
  }, React.createElement(Bank, {
    height: 24,
    name: isPnp ? activeMethod.pnpIcon : activeMethod.icon
  }), showQR ? "Starta ".concat(activeMethod.methodName, " p\xE5 den h\xE4r enheten") : "Starta ".concat(activeMethod.methodName)))), React.createElement(Button, {
    block: true,
    className: "",
    inverted: isPnp,
    onClick: () => {
      postMessageToParent({
        value: returnUrl,
        type: PARENT_REDIRECT
      });
      setShowAppLoader(false);
    },
    size: 300,
    transparent: true
  }, "Avbryt"));
};
svs.iam_idp.components.bank_id.BankIdStart = BankIdStart;

 })(window);